;(function ($) {
	"use strict";

	window.Settings = function (options) {
		this._init(options);
	};

	$.extend(Settings.prototype, {
		$options: {
			private: {
			}
		},

		//=====================================================================
		// Methods section
		//=====================================================================

		addMailInput: function ($button) {
			var app = this,
				$mailsWrapper = $button.closest('td').find('div.mails'),
				eventType = $button.data('eventType'),
				$input = $('<input type="text" placeholder="e-mail" class="form-control" name="alert_mail['+eventType+'][]">');
			
			$mailsWrapper.append($input);
		},

		removeMail: function ($button) {
			var $mailRow = $button.closest('div.alert-mail'),
				id = $button.data('removeEmailId'),
				$removedMailsInput = $('#removedAlertMails');
			
			$removedMailsInput.val($removedMailsInput.val() + id + ",");
			
			$mailRow.remove();
		},
		
		//=====================================================================
		// Controls section
		//=====================================================================

		/**
		 * HANDLE BUTTONS
		 */
		handleButtons: function() {
			var app = this,
				$document = $(document);

			$document.on('click', '.js-add-alert-mail', function (e) {
				e.preventDefault();
				app.addMailInput($(this));
			});

			$document.on('click', '.js-remove-alert-mail', function (e) {
				e.preventDefault();
				app.removeMail($(this));
			});
		},

		_init: function (options) {
			this.$options = $.extend({}, this.$options, options || {});

			this.handleButtons();
		},
	});

})(jQuery);

